import { DataService } from '../services/data_service';
import { IDs } from '../helpers/IDs';
import { i18nLang } from '../i18n/i18nLang';

const dataService = new DataService();
const config: any = require('../wips.config.js');
const devFeaturesMap: any = config.devFeaturesMap || {};
const autoTranslate = true;

export function i18n(key1: string, key2?: string): any {
    if (!devFeaturesMap.N207_MEHRSPRACHIGKEIT) {
        return key1;
    }
    if (typeof key1 !== 'string' || !key1) {
        return key1;
    }

    if (!i18nLang.locales['']) {
        i18nLang.locales[''] = {};
    }
    key2 = typeof key2 === 'string' ? key2 : '';
    if (!i18nLang.locales[key2]) {
        i18nLang.locales[key2] = {};
    }
    const key2_pre = getPrefix(key2);
    if (!i18nLang.locales[key2_pre]) {
        i18nLang.locales[key2_pre] = {};
    }

    if (i18nLang.locales[key2][key1]) {
        return i18nLang.locales[key2][key1];
    } else if (i18nLang.locales[key2_pre][key1]) {
        return i18nLang.locales[key2_pre][key1];
    } else {
        // console.log('no key', key1, key2, key2_pre);
        const uiLang = i18nLang.getUILang();
        if (autoTranslate && uiLang !== 'de') {
            doTranslate(key1, key2);
            return i18nLang.locales[key2][key1];
        }
    }

    return i18nLang.locales[''][key1] || key1;
}

export async function fetchTranslate(txt: string, lang: string, callback?: (translate: string) => void): Promise<string> {
    let translate: string = null;
    const response = await fetch(`https://translate.googleapis.com/translate_a/single?client=gtx&sl=de&tl=${lang}&dt=t&q=${encodeURIComponent(txt)}`);
    if (response.ok) {
        const res = await response.json();
        if (res && res[0] && res[0][0] && res[0][0][0]) {
            translate = res[0][0][0];
        }
    }
    if (typeof callback === 'function') {
        callback(translate);
    }
    return translate;
}

export async function fetchMultiTranslate(txtArr: string[], lang: string, callback?: (translate: string[]) => void): Promise<any> {
    const jsonStr = await fetchTranslate(JSON.stringify(txtArr), lang);
    let translate = [];
    try {
        translate = JSON.parse(jsonStr);
    } catch (e) {

    };
    if (typeof callback === 'function') {
        callback(translate);
    }
    return translate;
}

let cbCountdown = 0;
let cbTimeoutId: any;

function doTranslate(key1: string, key2: string): void {
    const uiLang = i18nLang.getUILang();
    i18nLang.locales[key2][key1] = '...'; // Placeholder?
    cbCountdown++;
    fetchTranslate(key1, uiLang, (translate: string) => {
        // console.log(key1, key2, '->', translate);
        i18nLang.locales[key2][key1] = translate;
        cbCountdown--;
        if (cbCountdown === 0) {
            if (typeof i18nLang.cbUpdateUI === 'function') {
                clearTimeout(cbTimeoutId);
                cbTimeoutId = window.setTimeout(() => {
                    console.log('Translation done!');
                    i18nLang.cbUpdateUI();
                }, 5000);
            }
        }
    });
    if (key2 === 'sys' || key2 === 'tab') {
        presetKeys(key1, key2);
    }
}

function presetKeys(key1: string, key2: string): void {
    if (key1 && key2) {
        const fnd = i18nLang.rows.find((r: any) => r.intern_key === key1 && r.intern_key2 === key2);
        if (!fnd) {
            const item = {
                tid: 0,
                intern_key: key1,
                intern_key2: key2
            }
            dataService.saveData(IDs.ENT_MEHRSPRACHIGKEIT, item, null, null, (suc: boolean, saveTid: number) => {
                console.log('presetKeys', key1, key2);
            }, IDs.MOD_ETOOL_ADMIN);
        }
    }
}

// Nicht mit presetKeys() gleich nutzen!
function saveTranslate(key1: string, key2: string, translate: string): void {
    if (key1 && key2 && translate) {
        const uiLang = i18nLang.getUILang();
        const fnd = i18nLang.rows.find((r: any) => r.intern_key === key1 && r.intern_key2 === key2);
        const tid = fnd && fnd.tid > 0 ? fnd.tid : 0;
        const item = {
            tid,
            intern_key: key1,
            intern_key2: key2,
            [uiLang]: translate
        }
        dataService.saveData(IDs.ENT_MEHRSPRACHIGKEIT, item, null, null, (suc: boolean, saveTid: number) => {
            console.log('saveTranslate', key1, key2, translate);
        }, IDs.MOD_ETOOL_ADMIN);
    }
}

function getPrefix(str: string): string {
    let prefix: string = '';
    const arr = (str || '').split('.');
    if (arr.length > 1) {
        prefix = arr[0];
    }
    return prefix;
}
